<script lang="ts" setup>
  import type { VPreloaderProps } from './types';

  withDefaults(defineProps<VPreloaderProps>(), {
    center: true,
    message: undefined,
  });
</script>

<template>
  <div
    class="Preloader flex items-center flex-col"
    :class="{ Preloader_Center: center }">
    <VLogo class="animate-pulse" data-testid="logo" />
    <p v-if="message" class="mt-16 text-center" data-testid="message">
      {{ message }}
    </p>

    <div
      class="Preloader_info absolute w-[100vw] max-w-[660px] p-16 mt-[145px]">
      <Message v-if="$slots.tip" :closable="false">
        <slot name="tip" />
      </Message>
    </div>
  </div>
</template>

<style>
  .Preloader_Center {
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .Preloader_info [data-pc-section='wrapper'] {
    gap: 10px;
  }

  .Preloader_info [data-pc-section='icon'] {
    width: 40px;
  }

  .Preloader_info [data-pc-section='wrapper'] {
    align-items: center;
  }
</style>
